import type { JSX } from 'react'
import type { ITVSimpleCardProps } from './TVSimpleCard'

import {
  TvHorizontalNumberSC,
  topNumberToPicture,
} from 'blocks/Cards/TopNumbers'
import { TopTvSimpleCardSC } from './TVCardDefault.styled'
import { TVSimpleCard } from './TVSimpleCard'

export interface ITopTvSimpleCard extends ITVSimpleCardProps {
  topNumber: number
}

export const TopTvSimpleCard = ({
  topNumber,
  onClick,
  ...rest
}: ITopTvSimpleCard): JSX.Element => {
  const TopNumberPicture = topNumberToPicture[topNumber]

  return (
    <TopTvSimpleCardSC onClick={onClick}>
      <TvHorizontalNumberSC>
        <TopNumberPicture />
      </TvHorizontalNumberSC>

      <TVSimpleCard {...rest} />
    </TopTvSimpleCardSC>
  )
}
